const paths = {
  index: `${process.env.NEXT_PUBLIC_API_HOST}/api/vendors/deals/:deal_id/deal_inspection_reports`
};

export const getDownloadPath = (dealId: number): string =>
  paths.index.replace(':deal_id', String(dealId));
